import React, { useState, useEffect, useRef } from 'react';
import Accordian from '../../common/components/Accordian/Accordian.js'
import logo from "../../common/media/cc_logo_white.svg";
import { formatNumber } from "../../common/util/numberFormatter";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { projects as getProjects } from '../../common/api/projects';
import ProjectsList from "./../Projects/ProjectsList";
import Popover from "../../common/components/popover/popover.js";
import facebook from "../../common/media/facebook.svg";
import instagram from "../../common/media/instagram.svg";
import twitter from "../../common/media/twitter.svg";
import { footerLinks } from '../../common/util/uiConfigs/footerConfiguration.js';
import logoWhite from '../../common/media/cc_logo_white.svg';

const LandingPage = ({ merchantCode, fetchedImpact }) => {
    const [projects, setProjects] = useState();

    const nftOffsetImpact = "39,674";//fetchedImpact && !fetchedImpact.error && formatNumber(fetchedImpact.treeGrowthYears?.value);
    const numberOfContributions = "16,561";//fetchedImpact && !fetchedImpact.error && formatNumber(fetchedImpact.numberOfContributions?.value);
    const carbonOffsetImpact = "9,027,350";//fetchedImpact && !fetchedImpact.error && formatNumber(Math.round(fetchedImpact.carbonOffsetImpact?.value));
    const carbonOffsetKwh = "11,981,034" ;//fetchedImpact && !fetchedImpact.error && fetchedImpact.carbonOffsetImpact?.unit

        
    useEffect(() => {
        getProjects(null, merchantCode)
            .then(response => response.json())
            .then(data => setProjects(data))
            .catch(setProjects);

    }, []);

    const scrollToSection = useRef(null);
    const executeScroll = () => scrollToSection.current.scrollIntoView();

    const treeMetric = `An average tree captures about 20kg of carbon dioxide per year, and about 1 tonne over its lifetime. By funding projects that offset carbon emissions, we are having the same impact as ${nftOffsetImpact} trees have in one year.`;

    return (
        <div>
            <div className="transparent-header">
                <div className="container">
                    <div className="row justify-content-between">
                        <div className="col-12 text-center">
                            <a href="https://www.nonfungiblelabs.xyz/" target="_blank">
                                <img src={`https://res.cloudinary.com/carbonclick/image/upload/v1642482751/Enterprise/Non-Fungible%20Labs/Logo-text-white_4x_1_k5uznb.svg`} style={{height: '91px'}} />
                            </a>
                        </div>
                    </div>
                                        
                </div>
            </div>
            <div className="w-100 img-cover hero-img main-banner" >
               
                <div className="container text-align-start vertical-align">
                    <div className="row align-items-center">
                        <div className="col-12">
                            <div className='text-center'>
                                <h1 className="mt-0 grd-1">CLIMATE POSITIVE NFTS!</h1>
                                <p className="text-white lrg line-30">Non-Fungible Labs is on a mission to mitigate climate change and offset <br/>the environmental impact minting NFTs on the blockchain. </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='text-left'>
                <div className='container'>
                    <div className="two-logos mx-auto">
                        <div className='grad-border height-1'></div>
                        <div className='gap-8 justify-center row'>
                            <img src={'https://res.cloudinary.com/carbonclick/image/upload/v1642482751/Enterprise/Non-Fungible%20Labs/Logo-text-white_4x_1_k5uznb.svg'} style={{ height: 46 }} alt="Non fungible labs logo" />
                            <img src={logoWhite} style={{ height: 26 }} alt="Carbonclick logo" />
                        </div>
                    </div>
                </div>
            </div>
            <div className='two-sec-outer'>
                <div className='container bg-container'>
                    <div className="rabit-box">
                        <div className='block-text'>
                            <h3 className="font-bold text-white grd-2 line-42">We’re taking climate action by DOUBLE offsetting the carbon emissions associated with our NFTs.</h3>
                            <p className="sml text-white-50">It's no secret that Ethereum is energy intensive because of the 'mining' process used to secure the network. Until we can be sustained on a fully renewable global electricity grid, minting events will inevitably cause carbon emissions. </p>
                            <p className="sml text-white-50">While Ethereum has begun the process of moving to a much more energy efficient mechanism to secure the network, this process is not yet complete. That’s why we are double offsetting the minting of all of our NFTs, meaning we are not just compensating for the environmental impact of our NFTs, but also giving something back to our shared planet. </p>
                        </div>
                    </div>
                    <div className='padding-bt'>
                        <div className='grad-border height-4'></div>
                    </div>
                </div>
            </div>
            <div className="py-90 customerCarbonImpact text-center text-white">
                <div>
                    <div className='padding-con'>
                        <h2 className="mt-0 text-primary">TOGETHER WE ARE FIGHTING CLIMATE CHANGE</h2>
                    </div>
                    <div className="mobile-hide text-center">
                        <div className='padding-con'>
                            <div className="row">
                                <div className="col-3 d-grid">
                                    <div className="w-100 icn-shdw-bx">
                                        <div>
                                            <div className="img-cover img-1">
                                                <img src={`https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1642481098/Enterprise/Non-Fungible%20Labs/image_55_ewcyma.jpg`} />
                                            </div>
                                            <div className="font-bold">
                                                <h2 className="count-title text-white mb-2 mt-4">{nftOffsetImpact}</h2>
                                                <p className="text-primary my-0">
                                                    <span className="mr-2">NFTs offset</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-3 d-grid">
                                    <div className="w-100 icn-shdw-bx">
                                        <div>
                                            <div className="img-cover img-1 w-100">
                                                <img src={`https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1642481098/Enterprise/Non-Fungible%20Labs/image_56_xjpvaq.jpg`}/>
                                            </div>
                                            <div className="font-bold">
                                                <h2 className="count-title text-white mb-2 mt-4">{numberOfContributions}</h2>
                                                <p className="text-primary  my-0">Transactions offset</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-3 d-grid">
                                    <div className="w-100 icn-shdw-bx">
                                        <div>
                                            <div className="img-cover img-1">
                                                <img src={`https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1642481098/Enterprise/Non-Fungible%20Labs/image_57_hfkdbi.jpg`} />
                                            </div>
                                            <div className="font-bold">
                                                <h2 className="count-title text-white mb-2 mt-4">{carbonOffsetImpact}</h2>
                                                <p className="text-primary  my-0">Kg of CO2 Offset</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-3 d-grid">
                                    <div className="w-100 icn-shdw-bx">
                                        <div>
                                            <div className="img-cover img-1">
                                                <img src={`https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1642481098/Enterprise/Non-Fungible%20Labs/image_58_rilr85.jpg`} />
                                            </div>
                                            <div className="font-bold">
                                                <h2 className="count-title text-white mb-2 mt-4">{carbonOffsetKwh}</h2>
                                                <p className="text-primary  my-0">kWh offset</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="mobile-show mt-4 text-center">
                    <div className="container">
                        <Carousel dynamicHeight={false} showThumbs={false} showArrows={false} showStatus={false} infiniteLoop={true} autoPlay={true}>
                            <div key="1">
                                <div className="w-100 icn-shdw-bx">
                                    <div>
                                        <div className="img-cover img-1">
                                            <img src={`https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1642481098/Enterprise/Non-Fungible%20Labs/image_55_ewcyma.jpg`} />
                                        </div>
                                        <div className="font-bold">
                                            <h2 className="count-title text-white mb-2 mt-4">{nftOffsetImpact}</h2>
                                            <p className="text-primary  my-0">NFTs offset</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div key="2">
                                <div className="w-100 icn-shdw-bx">
                                    <div>
                                        <div className="img-cover img-1 w-100">
                                            <img src={`https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1642481098/Enterprise/Non-Fungible%20Labs/image_56_xjpvaq.jpg`}/>
                                        </div>
                                        <div className="font-bold">
                                            <h2 className="count-title text-white mb-2 mt-4">{numberOfContributions}</h2>
                                            <p className="text-primary  my-0">NFT Transations offset</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div key="3">
                                <div className="w-100 icn-shdw-bx">
                                    <div>
                                        <div className="img-cover img-1">
                                            <img src={`https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1642481098/Enterprise/Non-Fungible%20Labs/image_57_hfkdbi.jpg`} />
                                        </div>
                                        <div className="font-bold">
                                            <h2 className="count-title text-white mb-2 mt-4">{carbonOffsetImpact}</h2>
                                            <p className="text-primary  my-0">Kg of CO2 Offset</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div key="4">
                                <div className="w-100 icn-shdw-bx">
                                    <div>
                                        <div className="img-cover img-1">
                                            <img src={`https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1642481098/Enterprise/Non-Fungible%20Labs/image_58_rilr85.jpg`} />
                                        </div>
                                        <div className="font-bold">
                                            <h2 className="count-title text-white mb-2 mt-4">{carbonOffsetKwh}</h2>
                                            <p className="text-primary  my-0">kWh offset</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Carousel>
                    </div>
                </div>
            </div>
            <div>
                <div className='container'>
                    <div className='grad-border height-4'></div>
                </div>
            </div>
            <div className='initiatives-sec'>
                <div className='container'>
                    <h2 className="mt-0 mb-2 text-primary text-center">OUR SUSTAINABILITY INITIATIVES</h2>
                    <p className='text-white-50 text-center lrg mb-35'>Non-Fungible Labs is commiting to supporting New Zealand biodiversity <br/>and restoring our beautiful takutai toana (marine and coastal areas). </p>
                    <div className='row align-items-center'>
                        <div className='col-md-6 text-center text-md-right'>
                            <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1642481099/Enterprise/Non-Fungible%20Labs/1_10_o7cxtm.png" />
                        </div>
                        <div className='col-md-6'>
                            <h3 className="font-bold text-white grd-2 mb-0 text-mob-center line-42">We have  donated $100K so far to Sustainable Coastlines, a New Zealand non-profit that supports communities to prevent litter and clean up waterways, creating beautiful beaches, healthier waters and inspired people.  </h3>
                        </div>
                    </div>
                </div>
            </div>
            <div className='timeline-sec text-center'>
                <div className='container'>
                    <h2 className='grd-1 mb-0'>TIMELINE</h2>
                    <p className='text-white-50 text-center lrg mb-35'>Non-Fungible Labs are committed to long term climate action and have partnered with CarbonClick to <br/>reduce our emissions and grow our positive climate impact.</p>
                    <div className='timeline-box'>
                        <ul>
                            <li>
                                <div>
                                    <p className='lrg m-0'>July 2021</p>
                                </div>
                                <div>
                                    <span className='lrg bg-grad'>CO2 on blockchain <br/>Proof of concept</span>
                                </div>
                            </li>
                            <li>
                                <div>
                                    <p className='lrg m-0'>October 2021</p>
                                </div>
                                <div>
                                    <span className='lrg bg-grad'>Funded CO2 asset with 840 tonnes of CO2 minted</span>
                                </div>
                            </li>
                            <li>
                                <div>
                                    <p className='lrg m-0'>February 2022</p>
                                </div>
                                <div>
                                    <span className='lrg bg-grad'>Offset the carbon footprint of <br/>minting all FLUF collection</span>
                                </div>
                            </li>
                            <li>
                                <div>
                                    <p className='lrg m-0'>Q2 2022</p>
                                </div>
                                <div>
                                    <span className='lrg bg-grad border-r-28'>Blockchain integration <br/>to offset ALL ONGOING <br/>transactions</span>
                                </div>
                            </li>
                            <li>
                                <div>
                                    <p className='lrg m-0'>Announced 2022</p>
                                </div>
                                <div>
                                    <span className='lrg bg-grad'>Phase 2</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div>
                <div className='container'>
                    <div className='grad-border height-4'></div>
                </div>
            </div>

            {Array.isArray(projects) &&
                <div className="py-90 projects projects-sec text-center">
                    <div className="container">
                        <div className="mb-4 pb-3">
                            <h2 className="text-primary mb-2 mt-0">SUPPORTING PROJECTS THAT FIGHT CLIMATE CHANGE</h2>
                            <p className="sml text-white-50 line-27">We support only the highest quality carbon offsetting projects around the world, to bring <br/>you peace of mind and results.</p>
                        </div>
                        <ProjectsList title={null} projects={projects} />
                    </div>
                </div>
            }

            <div className="faq-sec">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-10 mx-auto">
                            <h2 className="text-primary">CLIMATE POSITIVE FAQS</h2>
                            <div className="mb-3 center text-align-start">
                                <Accordian title={"Who are CarbonClick?"} >
                                    CarbonClick is a New Zealand technology company that exists to reverse climate change. By making carbon offsetting simple, trustworthy and cost effective,  we empower businesses and their customers with the tools to start tackling their carbon emissions.
                                </Accordian>
                                    <Accordian title={"What does carbon offsetting do?"}>
                                    <span className='mb-2 d-block'>CarbonClick follows industry best practice to ensure that the offsets provided have a real, measurable impact on mitigating climate change.</span>
                                    Projects are scrutinised against their independently verified selection methodology, which uses many of the same stringent requirements of ICROA Code of Best Practice, such as true additionality, ensuring credible baseline reporting and verifying project developers integrity. Only projects that have considerable co-benefits are considered, 
                                    such as improving biodiversity, creating sustainable jobs, empowering women and minorities and improving community health and wellbeing.
                                </Accordian>
                                <Accordian title={"What are carbon credits?"} >
                                    A carbon credit is mechanism used to measure and support projects that fight climate change. For every tonne of CO2 that a project manages to absorb or otherwise reduce, a carbon credit is issued. Carbon credits are certified by international standards and held in registries like the Gold Standard registry (international credits) and can be purchased to reduce the carbon impact of an initiative or activity.
                                </Accordian>
                                <Accordian title={"Where does the money go?"} >
                                    The money paid to CarbonClick for carbon credits goes towards certified carbon offset projects that have met the highest standards. The funds are distributed amongst carbon offset suppliers carrying out the projects and CarbonClick takes a margin on the carbon credits for sourcing projects, quality assurance, administration and transaction fees.
                                </Accordian>
                                <Accordian title={"How are the emissions calculated?"} >
                                CarbonClick uses the latest data on network hashrates, node locations, and emissions sources to calculate the carbon footprint of blockchain activity. We use a wide range of sources, including official emissions factors from relevant government agencies, CoinShares Research, Digiconomist, Ethernodes and more.
                                </Accordian>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>

            <div className="w-100 footer-img">
            <div className="container color-white">
                    <p className="xxsml font-700 mt-0 mb-3">POWERED BY</p>
                    <div className="d-flex">
                        <div>
                            <a href={footerLinks?.carbonclick} target="_blank" rel="noopener noreferrer">
                                <img style={{ height: 27 }} className="footer-logo" src={logo} alt="carbonclick" />
                            </a>
                        </div>
                        <div className="right">
                            <div>
                                <a href={footerLinks?.facebook} target="_blank" rel="noopener noreferrer">
                                    <img style={{ width: 30, marginRight: 4 }} src={facebook} alt="carbonclick" />
                                </a>
                                <a href={footerLinks?.instagram} target="_blank" rel="noopener noreferrer">
                                    <img style={{ width: 30, marginRight: 4 }} src={instagram} alt="carbonclick" />
                                </a>
                                <a href={footerLinks?.twitter} target="_blank" rel="noopener noreferrer">
                                    <img style={{ width: 30 }} src={twitter} alt="carbonclick" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <hr className="mb-4" />

                    <div className="row">
                        <div className="col">
                            <div className="mb-25"><a className="color-white medium" href={footerLinks?.aboutCarbonClick} target="_blank" rel="noopener noreferrer">About CarbonClick</a></div>
                            <div className="mb-25"><a className="color-white medium" href={footerLinks?.faq} target="_blank" rel="noopener noreferrer">FAQs</a></div>
                        </div>
                        <div className="col">
                            <div className="mb-25"><a className="color-white medium" href={footerLinks?.termsAndConditions} target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a></div>
                            <div className="mb-25"><a className="color-white medium" href={footerLinks?.privacyPolicy} target="_blank" rel="noopener noreferrer">Privacy policy</a></div>
                        </div>
                        <div className="col-4">
                            <div className="mb-25"><a className="color-white medium" href="mailto:hello+nonfungiblelabs@carbonclick.com" target="_blank" rel="noopener noreferrer">hello@carbonclick.com</a></div>
                        </div>
                    </div>
                </div>
            </div>

        </div> 
    )
}


export default LandingPage;